import { parseTime } from '@/utils/util'
export const searchForm = {
}

export const form = {
  name: '', // 简称
  line_id: undefined, // 业务线id
  pinyin: '', // 全称
  sync_xml_loc: '', // XML同步地址
  typeids: [], // 类别
  loc_rule: '', // 链接地址
  priority: '', // 权重值
  change_freq: undefined, // 更新频率
}

export const formArticle = {
  website_map_id: "", // 网站地图id
  category: 1, // 类别
  loc: '', // 链接地址
  priority: '', // 权重值
  change_freq: undefined, // 更新频率
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  name: [{ required: true, message: '请输入XML名称', trigger: 'change' }],
  pinyin: [
    {
      required: true,
      message: '请输入XML名称（拼音）',
      trigger: 'change'
    },
    {
      validator: function (rule, value, callback) {
        if (/^[a-zA-Zs_]{1,30}$/.test(value) === false) {
          callback(new Error("只能输入拼音和_"))
        } else {
          callback()
        }
      },
      trigger: "blur"
    }
  ],
  sync_xml_loc: [{ required: true, message: '请输入XML同步地址', trigger: 'change' }],
  loc_rule: [{ required: true, message: '请输入文章链接', trigger: 'change' }],
  change_freq: [{ required: true, message: '请选择更新频率', trigger: 'change' }],
  priority: [
    {
      required: true,
      message: '请输权重',
      trigger: 'change'
    },
    {
      validator: function (rule, value, callback) {
        if (/^0\.[0-9]{1}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/.test(value) === false) {
          callback(new Error("请输入0.0 - 1.0之间的数"))
        } else {
          callback()
        }
      },
      trigger: "blur"
    }
  ]
}

export const rulesArticle = {
  loc: [{ required: true, message: '请输入文章链接', trigger: 'change' }],
  change_freq: [{ required: true, message: '请选择更新频率', trigger: 'change' }],
  priority: [
    {
      required: true,
      message: '请输权重',
      trigger: 'change'
    },
    {
      validator: function (rule, value, callback) {
        if (/^0\.[0-9]{1}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/.test(value) === false) {
          callback(new Error("请输入0.0 - 1.0之间的数"))
        } else {
          callback()
        }
      },
      trigger: "blur"
    }
  ],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: 'XML名称',
    dataIndex: 'name',
    width: 200,
    align: 'center',
  },
  {
    title: 'XML名称（拼音）',
    width: 200,
    dataIndex: 'pinyin',
    align: 'center',
    scopedSlots: { customRender: 'pinyin' }
  },
  {
    title: '业务线',
    dataIndex: 'org',
    width: 200,
    align: 'center',
    scopedSlots: { customRender: 'org' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'center',
    width: 120,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 120,
    align: 'center',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 180,
    scopedSlots: { customRender: 'operator' }
  }
]

export const columnsArticle = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '属性',
    dataIndex: 'category',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '链接地址',
    dataIndex: 'loc',
    width: 200,
    align: 'center'
  },
  {
    title: '更新频率',
    dataIndex: 'change_freq',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'change_freq' }
  },
  {
    title: '权重',
    dataIndex: 'priority',
    width: 150,
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'center',
    width: 120,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 120,
    align: 'center',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 50,
    scopedSlots: { customRender: 'operator' }
  }
]
